import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import { fontFallback } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export type ErrorScreenProps = {
	onClick: () => void;
	illustration?: string;
	header?: ReactNode;
	description?: ReactNode;
	buttonMessage?: ReactNode;
	testId?: string;
};

export const ErrorScreen = ({
	onClick,
	illustration,
	header,
	description,
	buttonMessage,
	testId,
}: ErrorScreenProps) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Box xcss={errorStyles} testId={testId}>
				{illustration && (
					<Illustration src={illustration} aria-describedby="error-icon" role="img" alt="" />
				)}
				{header && <Box xcss={headingStyles}>{header}</Box>}
				{description && <Box xcss={descriptionStyles}>{description}</Box>}
				<Button appearance="primary" onClick={onClick}>
					{buttonMessage || formatMessage(messages.refresh)}
				</Button>
			</Box>
		</>
	);
};

const errorStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	width: '100%',
	height: '100%',
	flexDirection: 'column',
	justifyContent: 'center',
});

const headingStyles = xcss({
	font: token('font.heading.medium'),
	marginTop: token('space.400', '32px'),
	marginBottom: token('space.100', '8px'),
});

const descriptionStyles = xcss({
	color: 'color.text.subtle',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	font: token('font.body', fontFallback.body.medium),
	paddingBottom: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const Illustration = styled.img({
	maxWidth: '160px',
	width: '50%',
	height: '50%',
	marginTop: token('space.1000', '80px'),
});
